// extracted by mini-css-extract-plugin
export default {"TextContainer":"DrawerAdvanced_TextContainer__yZyRv","ListText":"DrawerAdvanced_ListText__cG4yS"};